import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";

@Injectable()
export class PushSubscriptionService {
  private subscription: any;
  private loggedIn: boolean;
  private globalLogin: boolean = true;

  constructor(private authorizedService: AuthorizedService) {
    authorizedService.loadAppConfig().subscribe((config) => {
      this.globalLogin = config.global_login;

      authorizedService.statusChange.subscribe((status) => {
        this.loggedIn = status;

        if ((!config.global_login || status) && this.subscription) {
          authorizedService.post(ServiceConfig.push.subscribe, {subscription: this.subscription}).subscribe();
        }
      });
    });
  }

  public setSubscription(subscription: any) {
    this.subscription = subscription;

    if (!this.globalLogin || this.loggedIn) {
      this.authorizedService.post(ServiceConfig.push.subscribe, {subscription: this.subscription}).subscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/push-subscription.service.ts